import { render } from "./Contact.vue?vue&type=template&id=68771a03&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=68771a03&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Carla\\Projects\\Personal\\my-personal-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68771a03"]])

export default __exports__